import {Component, OnInit, OnDestroy} from '@angular/core';
// import * as _ from 'lodash';
import {StoreService, MockApiService} from '../../shared';
import {AlertService} from '../../shared/alert/alert.service';
import {EventService} from '../../shared/event/event.service';
import {ThreatService} from '../../shared/threat/threat.service';
import {BubbleChartComponent} from '../../components';
import {constructDependencies} from '@angular/core/src/di/reflective_provider';
import {CognitoAuthService} from '../../shared/auth/cognito.service';

declare const _: any;
declare const moment: any;

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    providers: [AlertService, EventService, ThreatService]
})

export class DashboardComponent implements OnInit, OnDestroy {

    _: any;
    isThreatsDataLoading = true;
    isThreatsDataError = false;
    maxThreatDataCallRetries = 3;
    threatsDataSubscription;
    subscriptions: any = {
        autoRefresh: null,
        threats: null
    };

    summaryData: any;

    threats = [];
    threatsParams: any[ ] = [
        {
            timePeriod: 'a',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'h',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'd',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'w',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'm',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'q',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'y',
            param2: null,
            param3: null,
        }
    ];

    timePeriods = ['a', 'h', 'd', 'w', 'm', 'q', 'y'];
    timePeriodIndex = 3;
    timePeriod = 'w';

    threatsFromAPI = [];

    threatChartType: number;
    threatTimePeriod: string;
    threatChartConfig = {
        x: [],
        y: []
    };

    threatChartData = {
        x: {
            labels: []
        },
        y: {
            labels: []
        },
        series: []
    };

    // Default Alert Time alertTimePeriod
    alertTimePeriod = 'w';
    showRanges = false;

    // Default Device Time Period
    deviceTimePeriod = 'none'; // XXX:  represents no timeperiod

    risks = ['INFO', 'LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
    riskClasses = ['bg-risk-info', 'bg-risk-low', 'bg-risk-medium', 'bg-risk-high', 'bg-risk-critical'];
    icons = ['bomb', 'bug', 'sliders', 'crosshairs', 'info-circle'];

    isAlertsTooltipOpen: boolean;

    isAlertsPopoverOpen: boolean;
    isDevicesPopoverOpen: boolean;

    deviceType = '';
    threatType = '';
    threatTooltipType = '';

    isAlertsModalOpen: boolean;
    isInsightModalOpen: boolean;

    topTilesMockData = [
        {
            title: 'This Week',
            data: [
                {
                    icon: 'bomb',
                    name: 'System Compromise',
                    value: 18,
                    segments: [4, 0, 14]
                },
                {
                    icon: 'bug',
                    name: 'Exploitation & Installation',
                    value: 15,
                    segments: [11, 4, 0]
                },
                {
                    icon: 'sliders',
                    name: 'Delivery & Attack',
                    value: 24,
                    segments: [4, 17, 3]
                },
                {
                    icon: 'crosshairs',
                    name: 'Reconnaissance & Probing',
                    value: 41,
                    segments: [20, 5, 16]
                },
                {
                    icon: 'info-circle',
                    name: 'Organizational Insight',
                    value: 2,
                    segments: [0, 2, 0]
                }
            ]
        },
        {
            title: 'This Month',
            data: [
                {
                    icon: 'bomb',
                    name: 'System Compromise',
                    value: 71,
                    segments: [4, 4, 16]
                },
                {
                    icon: 'bug',
                    name: 'Exploitation & Installation',
                    value: 39,
                    segments: [2, 9, 2]
                },
                {
                    icon: 'sliders',
                    name: 'Delivery & Attack',
                    value: 31,
                    segments: [0, 5, 5]
                },
                {
                    icon: 'crosshairs',
                    name: 'Reconnaissance & Probing',
                    value: 124,
                    segments: [9, 12, 20]
                },
                {
                    icon: 'info-circle',
                    name: 'Organizational Insight',
                    value: 35,
                    segments: [3, 8, 0]
                }
            ]
        },
        {
            title: 'This Year',
            data: [
                {
                    icon: 'bomb',
                    name: 'System Compromise',
                    value: 71,
                    segments: [4, 4, 16]
                },
                {
                    icon: 'bug',
                    name: 'Exploitation & Installation',
                    value: 39,
                    segments: [2, 9, 2]
                },
                {
                    icon: 'sliders',
                    name: 'Delivery & Attack',
                    value: 31,
                    segments: [0, 5, 5]
                },
                {
                    icon: 'crosshairs',
                    name: 'Reconnaissance & Probing',
                    value: 124,
                    segments: [9, 12, 20]
                },
                {
                    icon: 'info-circle',
                    name: 'Organizational Insight',
                    value: 35,
                    segments: [3, 8, 0]
                }
            ]
        }
    ];

    constructor(private store: StoreService,
                private mockApi: MockApiService,
                private threatService: ThreatService,
                private authService: CognitoAuthService) {
        this._ = _;
        this.summaryData = {
            summary: [],
            highRiskDevices: [],
            insight: []
        };

        this.threatChartType = 0;
        this.threatTimePeriod = 'w';

    }

    ngOnInit() {

        const self = this;

        self.subscriptions.timePeriod = self.store.onChange('timePeriod', function (val) {
            self.timePeriod = val;
        });

        self.subscriptions.autoRefresh = self.store.onChange('autoRefresh', function (val) {
            console.log('>>>>>>>> Refreshing threats! >>>>>>>> ', val);
            self.refresh();
        });

        self.subscriptions.summaryData = self.mockApi.getMockData('customer-report.json').subscribe((data) => {
            console.log('summaryData =', data);
            self.summaryData = data;
        });

        self.subscriptions.threats = self.store.onChange('threats', function (threats) {
            self.threatsFromAPI = threats;
        });

        // XXX: this needs to factor in the time period as well!
        self.subscriptions.devices = self.store.onChange('devices', function(devices) {
            const types = [];
            self.summaryData.insight.forEach(function(element) {
                types[element.type] = 0;
            });
            if (devices.length > 1) {
                devices[0].forEach(function(device){
                    types[device.type] += 1;
                });
            } else {
                devices.forEach(function(device){
                    types[device.type] += 1;
                });
            }
            devices.forEach(function(device){
                types[device.type] += 1;
            });
            self.summaryData.insight.forEach(function(element) {
                element.count = types[element.type];
            });
        });

        // this.refresh(false);
    }

    refresh(silent = true) {
        this.getThreats(this.timePeriodIndex, true, silent);
    }

    getThreats(threatsParamsIndex, forceFetchThreatsFromAPI = false, silent = false) {

        const self = this;

        if (!silent) {
            self.isThreatsDataLoading = true;
        }

        const params = self.threatsParams[threatsParamsIndex];

        self.threatService.getThreats(params, forceFetchThreatsFromAPI).subscribe(function (threats) {

            // self.threats = threats;
            self.store.update('threats', threats);
            self.isThreatsDataLoading = false;
            self.isThreatsDataError = false;
            self.prepareThreatBubbleChartData();

            // console.log('self.threats = ', self.threats);

        }, function (err) {

            // console.log('Error in getting threats. Called from dashboard.component.ts');
            // console.log(err);

        });
    }

    getThreatsOldWay() {
        let self = this;

        this.authService.getIdToken({
            callback() {
            },
            callbackWithParam(idToken: any) {
                const customer = self.authService.decodeToken(idToken)['custom:customer'];
                self.threatService.getThreats(idToken, customer).subscribe(function (threats) {

                    self.threatsFromAPI = threats;
                    self.isThreatsDataLoading = false;
                    self.isThreatsDataError = false;
                    self.prepareThreatBubbleChartData();

                }, function (err) {

                    console.log('Error in getThreats() of dashboard.component');

                    self.threatsFromAPI = [];
                    self.isThreatsDataLoading = false;
                    self.isThreatsDataError = true;

                    self.threatsDataSubscription.unsubscribe();
                    --self.maxThreatDataCallRetries;
                    if (self.maxThreatDataCallRetries > 0) {
                        self.refresh();
                    }

                });
            }
        });
    }

    prepareThreatBubbleChartData() {

        this.threatChartData = {
            x: {
                labels: []
            },
            y: {
                labels: this.threatService.threatTypes.slice()
            },
            series: []
        };

        const noOfDaysToDisplay = 7;
        let timeBlocksInADay = 6;
        const now = moment().startOf('day');

        for (let d = noOfDaysToDisplay - 1; d >= 0; d--) {
            let dateLabel = moment(now).subtract(d, 'days').format('MM/DD/YYYY');
            this.threatChartData['x'].labels.push(dateLabel);
        }

        let series = [];
        for (let i = 0; i < this.threatChartData['y'].labels.length; i++) {
            series[i] = [];
            for (let j = 0; j < noOfDaysToDisplay; j++) {
                series[i][j] = [];
                for (let k = 0; k < timeBlocksInADay; k++) {
                    series[i][j][k] = [0, 0];
                }
            }
        }

        this.threatsFromAPI.forEach(function (threat) {
            if (threat.hour <= 4) {
                threat.hour = 24 - threat.hour - 4;
                let temp = new Date(threat.date);
                let temp_date = moment(temp).format('YYYY-MM-DD');
                threat.date = temp_date + 'T00:00:00.000Z';

            } else {
                threat.hour = threat.hour - 4;
            }

            let date = moment(threat.date);
            let diffDays = now.diff(date, 'days');

            if (diffDays < 0 || diffDays > noOfDaysToDisplay) {
                return;
            }

            let row = threat.threat;
            let day = (noOfDaysToDisplay - 1) - diffDays;

            if (day < 0) {
                return;
            }

            let block = Math.floor(threat.hour / 4);
            let color = threat.severity;
            let size = Math.min(10, Math.ceil(threat.count / 2));
            let title = 'Count: ' + threat.count;
            series[row][day][block] = [color, size, title];
        });

        this.threatChartData['series'] = series;
    }

    getClassForThreatBubble(z) {

        const risks = ['low', 'medium', 'high'];
        const risk = 'bg-risk-' + risks[z[0]];
        const size = 'p-' + (z[1] * 10);
        return risk + ' ' + size;

    }

    changeTimePeriod(t) {

        this.threatTimePeriod = t;

    }

    onBubbleMouseOver(obj, z) {

        /*
         console.log('onBubbleMouseOver');
         console.log(obj);
         console.log(z);
         */

    }

    onThreatSummaryMouseOver(type: string) {
        // TODO: Pass threatType parameter to alerts-table
        this.openAlertsTooltip(type);
        // this.openAlertsModal();
    }

    onThreatSummaryMouseOut() {
        // TODO: Pass threatType parameter to alerts-table
        this.closeAlertsTooltip();
        // this.openAlertsModal();
    }

    onThreatSummaryClick(type: string) {
        this.openAlertsPopover(type);
        // this.openAlertsModal();
    }

    onInsightSummaryClick(type: string) {
        this.openDevicesPopover(type);
        // this.openDevicesModal();
    }

    openAlertsTooltip(type) {
        this.isAlertsTooltipOpen = true;
        this.threatTooltipType = type;
    }

    closeAlertsTooltip() {
        this.isAlertsTooltipOpen = false;
    }

    openAlertsPopover(type) {
        this.isAlertsPopoverOpen = true;
        this.threatType = type;
    }

    closeAlertsPopover(evt) {
        this.isAlertsPopoverOpen = false;
    }

    openDevicesPopover(type) {
        this.isDevicesPopoverOpen = true;
        this.deviceTimePeriod = 'w'; // TODO: temporary - take value from overall time period of page
        this.deviceType = type;
    }

    closeDevicesPopover(evt) {
        this.isDevicesPopoverOpen = false;
    }

    openAlertsModal() {
        this.isAlertsModalOpen = true;
    }

    closeAlertsModal() {
        this.isAlertsModalOpen = false;
    }

    openDevicesModal() {
        this.isInsightModalOpen = true;
    }

    closeDevicesModal() {
        this.isInsightModalOpen = false;
    }

    ngOnDestroy() {

        // console.log('onDestroy called on DashboardComponent');

        const self = this;

        Object.keys(self.subscriptions).forEach(function (key) {
            if (self.subscriptions[key]) {
                self.subscriptions[key].unsubscribe();
            }
        });
    }

}



// WEBPACK FOOTER //
// /app/src/app/containers/dashboard/dashboard.component.ts